module.exports = __webpack_public_path__ + "static/img/PK42.8a576f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK42.jpg
// module id = H3RT
// module chunks = 0